export const blockIconsNotificationWifi = (
	<span className='material-symbols-outlined'>wifi</span>
);
